import { usePath } from './usePath';
import { ROUTES } from '../../constants';
import { useNavigateTo } from './useNavigateTo';
import { useSearchParams } from 'next/navigation';

interface useNavigationResult {
    isProjectPath: boolean;
    isMatchingScreen: boolean;
    isCompaniesScreen: boolean;
    isHomeScreen: boolean;
    isFaqScreen: boolean;
    navigateToProjectDetails: (projectId: string) => void;
    navigateToCompanyDetails: (companyId: string) => void;
}

export function useCustomNavigate(): useNavigationResult {
    const path = usePath();
    const navigateTo = useNavigateTo();
    const searchParams = useSearchParams();

    const isProjectPath = path.includes(ROUTES.Projects);
    const isMatchingScreen = path === ROUTES.Matching;
    const isCompaniesScreen = path === ROUTES.Companies;
    const isHomeScreen = path === ROUTES.Home;
    const isFaqScreen = path === ROUTES.Service && searchParams.get('tab') === 'faq';

    function navigateToProjectDetails(projectId: string) {
        navigateTo(ROUTES.ProjectDetails.replace(':projectId', projectId));
    }

    function navigateToCompanyDetails(companyId: string) {
        navigateTo(ROUTES.CompanyDetails.replace(':companyId', companyId));
    }

    return {
        isProjectPath,
        isMatchingScreen,
        isCompaniesScreen,
        isHomeScreen,
        isFaqScreen,
        navigateToProjectDetails,
        navigateToCompanyDetails
    };
}
